export function youtubeEmbedSrc(id: string, inline = true): string {
  const params = `enablejsapi=1&autoplay=1&rel=0&modestbranding=1${inline ? "&playsinline=1" : ""}`;
  return `https://www.youtube-nocookie.com/embed/${id}?${params}`;
}

export function youtubeThumbnail(id: string): string {
  return `https://i.ytimg.com/vi/${id}/maxresdefault.jpg`;
}

export function youtubeShortThumbnail(id: string): string {
  return `/data/youtube/${id}.jpg`;
}

export function posterFallback(e: { currentTarget: HTMLImageElement }): void {
  const img = e.currentTarget;
  const next = img.src.replace(/\/maxresdefault\.jpg$/, "/hqdefault.jpg");
  if (next !== img.src) img.src = next;
}
